export enum SearchField {
  SearchValue = 'searchValue',
}
